export default function HtmlText({html, children, className}){
    return <div className={className} dangerouslySetInnerHTML={{__html: html || children}} />;
}